import React from "react";
import { LegalShell, H2, P, UL } from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" updated="June 2026" testid="terms-page">
      <P>These Terms of Service ("Terms") govern your use of iYeneh Connect, a service operated by Capital Defense Institute LLC ("iYeneh", "we", "us"), a global communications, broadcasting and digital-services platform. By creating an account or using our services, you agree to these Terms.</P>

      <H2>Your Account</H2>
      <UL>
        <li>You must provide accurate information and verify your mobile number to use the services.</li>
        <li>You are responsible for keeping your login credentials secure and for activity on your account.</li>
        <li>You must be old enough to form a binding contract in your country.</li>
      </UL>

      <H2>Wallet, Payments & Billing</H2>
      <UL>
        <li>Many services are pay-as-you-go and draw from your iYeneh wallet balance. Rates are shown before you buy.</li>
        <li>Subscriptions and business add-ons renew per their stated terms; you can manage or cancel them from your account.</li>
        <li>Payments are processed by third-party providers. Wallet credit and applicable fees are non-refundable except where required by law.</li>
      </UL>

      <H2>Acceptable Use</H2>
      <P>You agree not to use iYeneh to send spam or unlawful communications, to harass or defraud others, to infringe intellectual property, or to violate telecom, messaging or data-protection laws. Marketing messages you send through the platform must comply with applicable consent and opt-out rules (including SMS 10DLC and WhatsApp policies).</P>

      <H2>Third-Party Services</H2>
      <P>Some features rely on third parties (for example telecom carriers, payment processors and SI providers). Your use of those features may also be subject to their terms.</P>

      <H2>Service Availability</H2>
      <P>We work to keep the platform reliable but do not guarantee uninterrupted service. Features may change, and some depend on external networks and carriers.</P>

      <H2>Disclaimers & Liability</H2>
      <P>The services are provided "as is". To the maximum extent permitted by law, iYeneh is not liable for indirect or consequential damages. Nothing in these Terms limits liability that cannot be limited by law.</P>

      <H2>Termination</H2>
      <P>You may stop using iYeneh at any time. We may suspend or terminate accounts that violate these Terms or applicable law.</P>

      <H2>Changes</H2>
      <P>We may update these Terms; material changes will be posted here with a new "Last updated" date. Continued use means you accept the updated Terms.</P>

      <H2>Contact</H2>
      <P>Questions about these Terms? Email <a className="text-white underline" href="mailto:support@iyeneh.com">support@iyeneh.com</a> or message us on WhatsApp at <a className="text-white underline" href="https://wa.me/12029403399" target="_blank" rel="noreferrer">+1 202 940 3399</a>.</P>
    </LegalShell>
  );
}
